module.exports = __webpack_public_path__ + "static/media/arrow-list.a9e38487.svg";